import React, { useState, useRef } from 'react';
import Modal from './Modal';
import SimplePagePopUp from './SimplePagePopUp';
const TermsModal = ({ terms, linkText, termsText, termsSecondaryText }) => {
  const [dialogShow, setDialogShow] = useState(true);
  const [animation, setAnimation] = useState(false);
  const [privacyOptIn, setPrivacyOptIn] = useState(false);
  const modal = useRef(null);
  const switchDialog = () => {
    const dialog = modal.current;
    setDialogShow((prevState) => !prevState);
    if (dialogShow) {
      dialog.showModal();
      setAnimation('open-modal');
    } else {
      setAnimation('close-modal');
      setTimeout(() => {
        dialog.close();
      }, 200);
    }
  };
  return (
    <>
      <input
        className="checkbox"
        type="checkbox"
        required
        name="terms-and-conditions"
        checked={privacyOptIn}
        onChange={(e) => {
          setPrivacyOptIn(e.target.checked);
        }}
      />
      <p className="terms-text">
        {termsText}
        <button onClick={switchDialog}>{linkText}</button> {termsSecondaryText}
      </p>
      <Modal
        animation={animation}
        dialogShow={dialogShow}
        modal={modal}
        switchDialog={switchDialog}
      >
        <div className="modal-simple-website">
          <SimplePagePopUp
            simpleModularContent={terms.simpleModularContent}
            title={terms.title}
            slug={terms.slug}
          />
        </div>
      </Modal>
    </>
  );
};

export default TermsModal;
